import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const dreamupGenerationSucceeded = createAction(`${actionKey}.GENERATION_SUCCEEDED`, (generationId, deviationIds)=>({
        generationId,
        deviationIds
    }));
export const dreamupGenerationFailed = createAction(`${actionKey}.GENERATION_FAILED`, (generationId)=>({
        generationId
    }));
